<template>
  <div class="home z-20 relative">    
    <Card title="greeting-error"> 
      <div class="max-w-buttonCover mx-auto mt-20 w-full">
        <a href="https://www.tinaba.bancaprofilo.it/support" class="block w-full bg-primary text-white font-bold py-2 px-4 rounded-20">  {{ $t("error-not-found") }} </a>
      </div>
    </Card>
  </div>
</template>
<script>
import Card from '@/components/Card.vue'
import { mapMutations } from 'vuex'

export default {
  name: 'ErrorNotFound',
  components: {
    Card
  },
  methods: {
    ...mapMutations('linkToPay', ['toggleLoading'])
  },
  mounted () {
    this.toggleLoading({ isLoading: false })
  }
}
</script>